<template>
  <button
    class="control-button"
    @click="player.togglePanel(PanelType.INFO)"
    :aria-label="t('player.controls.info')"
    :data-tooltip="t('player.controls.info')"
    :aria-expanded="player.activePanel.value === PanelType.INFO"
    v-html="infoIcon"
  />
</template>

<script setup lang="ts">
import { infoIcon } from '../../assets/icons'
import { PanelType } from '../../types'
import { useVideoI18n } from '../../i18n'
import type { UseVideoPlayerReturn } from '../../composables/useVideoPlayer'

defineProps<{
  player: UseVideoPlayerReturn
}>()

const { t } = useVideoI18n()
</script>

<style scoped>
/* Styles are in main.scss */
</style>
